import { useCachedSsrRef } from "./serverCache.mjs";
import { BrandDocument, BrandsDocument } from "../graphql/Brand.mjs";
import { toNonNullable } from "../utils/collections.mjs";
import { useQuery } from "villus";
import { ref, watch } from "vue";
import { useState } from "#app";
export function fetchBrands() {
  const { data, error, execute, isFetching } = useQuery({
    query: BrandsDocument,
    fetchOnMount: false
  });
  return {
    execute,
    isFetching,
    data,
    error
  };
}
export function fetchBrand() {
  const { data, error, execute, isFetching } = useQuery({
    query: BrandDocument,
    fetchOnMount: false
  });
  return {
    execute,
    isFetching,
    data,
    error
  };
}
export async function useBrands(_fetchBrands = fetchBrands) {
  const cachedBrands = useCachedSsrRef("brands", []);
  const { execute, isFetching } = _fetchBrands();
  const brands = await (async () => {
    if (cachedBrands.value?.length) {
      return cachedBrands.value;
    }
    const { data, error } = await execute();
    if (error) {
      throw new Error(error.message);
    }
    cachedBrands.value = toNonNullable(data?.brands?.items || []);
    return cachedBrands.value;
  })();
  return {
    brands,
    isFetching
  };
}
export async function useFeaturedBrands(_fetchBrands = fetchBrands) {
  const cachedBrands = useCachedSsrRef("brands", []);
  const { execute, isFetching } = _fetchBrands();
  const brands = await (async () => {
    if (cachedBrands.value.length) {
      return cachedBrands.value;
    }
    const { data, error } = await execute();
    if (error) {
      throw new Error(error.message);
    }
    cachedBrands.value = data?.brands?.items?.filter(
      (brand) => brand?.is_shown_in_homepage === 1
    ) || [];
    return cachedBrands.value;
  })();
  return {
    brands,
    isFetching
  };
}
export async function useBrand(slug, _fetchBrand = fetchBrand) {
  const cachedBrand = useState(
    "brand",
    () => null
  );
  const { execute, isFetching } = _fetchBrand();
  const error = ref(null);
  const brand = await (async () => {
    const { data, error: _error } = await execute({
      variables: {
        slug
      }
    });
    cachedBrand.value = data?.brand;
    error.value = _error;
    return cachedBrand.value;
  })();
  return {
    brand,
    isFetching,
    error
  };
}
export function useSearchByLetter(brands) {
  const threshold = 27;
  const result = ref([]);
  const letter = ref(null);
  watch(
    letter,
    (newLetter) => {
      if (!newLetter) {
        let count = 97;
        result.value = [];
        while (count !== 122 && result.value.length !== threshold) {
          result.value = brands.value?.filter((brand) => {
            return brand?.name.toLowerCase().charCodeAt(0) === count;
          }) ? [
            ...result.value,
            {
              letter: count,
              payload: brands.value?.filter((brand) => {
                return brand?.name.toLowerCase().charCodeAt(0) === count;
              }).map((brand) => ({
                url: brand?.url_key || "",
                name: brand?.name || "",
                image: brand?.image_url || ""
              })) || []
            }
          ] : result.value;
          count++;
        }
        return;
      }
      if (!newLetter) {
        return;
      }
      result.value = [
        {
          letter: newLetter,
          payload: brands.value.filter((brand) => {
            return brand?.name.toLowerCase().charCodeAt(0) === newLetter;
          }).map((brand) => ({
            url: brand?.url_key || "",
            name: brand?.name || "",
            image: brand?.image_url || ""
          })) || []
        }
      ];
    },
    {
      immediate: true
    }
  );
  watch(
    brands,
    (newBrands) => {
      if (newBrands?.length)
        letter.value = null;
    },
    {
      immediate: true
    }
  );
  return {
    result,
    letter
  };
}
